import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFoundPage() {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center px-6 text-center bg-brand-bg">
      <SEO title="Página no encontrada · Club Amistad" description="404" path="/404" noindex />
      <img src="/club-amistad-logo.png" alt="Club Amistad" className="h-20 w-auto mb-6 opacity-90" />
      <p className="overline">Error 404</p>
      <h1 className="h1-display mt-4">Esta pista no existe en nuestra estación</h1>
      <p className="body-lg mt-5 max-w-xl">
        La página que buscas se ha perdido entre la nieve. Vuelve al inicio y elige uno de nuestros viajes
        en familia.
      </p>
      <Link to="/" className="btn-primary mt-8" data-testid="back-home-link">Volver al inicio</Link>
    </div>
  );
}
